import _ from "lodash";

export const getTextureValue = (product: any): number => {
  if (product.texture !== undefined) {
    if (product.step === "Step 1") {
      return _.indexOf(textureStep1, product.texture) + 1;
    } else {
      return _.indexOf(textureStep2, product.texture) + 1;
    }
  } else {
    return 0;
  }
};

export const getTextureLabel = (product: any): any => {
  return [
    {
      value: 1,
      label: "Watery",
    },
    {
      value: getTextureValue(product),
      label: product.texture,
    },
    {
      value: 8,
      label: "Oil",
    },
  ];
};

const textureStep1 = [
  "Watery",
  "Scrub",
  "Mousse",
  "Foaming gel",
  "Cream",
  "Milky",
  "Blam",
  "Oil",
];

const textureStep2 = [
  "Watery",
  "Concentrate",
  "Serum",
  "Gel",
  "Lotion",
  "Cream",
  "Blam",
  "Oil",
];
